import Exercise from './Exercise';

export default class ExerciseForm {
  constructor(name = '', equipment = [], categories = [], id = null, musclegroup = [], tags = [], explanation = [[] ,[]], video = [], trainer = null,  publishable = null, primaryStatus = null, statuses = []) {
    this.categories = categories;
    this.equipment = equipment;
    this.explanation = explanation;
    this.id = id;
    this.musclegroup = musclegroup;
    this.name = name;
    this.tags = tags;
    this.trainer = trainer;
    this.video = video;
    this.publishable = publishable; 
    this.primaryStatus = primaryStatus;
    this.statuses = statuses;
  }

  formatforDB() {
    const data = {
      categories: this.categories.map( item => item.toLowerCase().replace(/\s+/g, '-') ),
      equipment_alt: this.equipment.map(e => typeof(e) === 'number' ? e : e.id),
      explanation: this.explanation.map(list => list.filter(item => item ? true : false)),
      id: this.id,
      musclegroup: this.musclegroup.map(mg => typeof(mg) === 'object' ? mg.id : mg),
      name: this.name,
      tags: this.tags.map(item => item.value),
      trainer: this.trainer,
      video: this.video.map(item => item.id),
      publishable: this.publishable,
    }

    return new Exercise(
      data.categories,
      data.equipment_alt,
      data.explanation,
      data.id,
      data.musclegroup,
      data.name,
      data.tags,
      data.trainer,
      data.video,
      data.publishable,
    );
  }

  formatForForm(obj, props) {
    const exer = new Exercise();
    if(obj) {
      for (const key in exer) {
        if (obj.hasOwnProperty(key)) {
          exer[key] = obj[key];
        }
      }
    }

    this.categories = exer.categories;
    this.equipment = exer.equipment;
    this.explanation = exer.explanation;
    this.id = exer.id;
    this.musclegroup = exer.musclegroup;
    this.name = exer.name;
    this.tags = exer.tags.map(item => ({label: item, value: item}));
    this.trainer = exer.trainer;
    this.video = exer.video;
    this.publishable = exer.publishable;
    
    this.checkValidity(props);
  }

  checkValidity(props) {
    let primaryStatus = 'Valid';
    let statusList = {};

    const nameText = 'Exercise name';
    const videoText = 'Uploaded a demonstration video which visually demonstrates the exercise with correct form';

    if (this.name !== '') {
      statusList.name = {value: true, text: nameText};
    } else {
      primaryStatus = 'Invalid';
      statusList.name = {value: false, text: nameText};
    }

    if (this.video.length > 0) {
      statusList.video = {value: true, text: videoText};
    } else {
      primaryStatus = 'Invalid';
      statusList.video = {value: false, text: videoText};
    }

    this.primaryStatus = primaryStatus;
    this.statuses = statusList;
  }
}
